import { compose, join, split, reverse, map } from 'ramda'
import strings from 'utils/strings'

export const GERERAL_SHORT_TIME_FORMAT = '00:00:00.0'

const parseHmsNumbers = (value = 0) => {
  const hoursInt = parseInt(value / 36000, 10)
  const minutesInt = parseInt((value - hoursInt * 36000) / 600, 10)
  const secondsStr = (
    (value - hoursInt * 36000 - minutesInt * 600) /
    10
  ).toFixed(1)

  return {
    hours: hoursInt,
    minutes: minutesInt,
    seconds: secondsStr,
  }
}

const parseHmsStrings = (value = 0) => {
  const { hours, minutes, seconds } = parseHmsNumbers(value)

  return {
    hours: hours.toString(),
    minutes: pad0(minutes),
    seconds: pad0(seconds),
  }
}

const pad0 = (num) => (num < 10 ? `0${num}` : num.toString())

const formatTimeForInput = (value) => {
  const { hours, minutes, seconds } = parseHmsStrings(value)
  const removeDecimal = compose(join(''), split('.'))

  return `${hours}${minutes}${removeDecimal(seconds)}`
}

// split timer value and convert to floats
const splitToFloats = compose(map(parseFloat), reverse, split(':'))

const timerValue = (value) => {
  const { seconds, minutes, hours } = parseHmsNumbers(value)

  return strings.timer_value(hours, minutes, seconds)
}

// Full word version for delay texts (not abbreviated)
const timerValueFull = (value) => {
  const { seconds, minutes, hours } = parseHmsNumbers(value)

  return strings.timer_value_full(hours, minutes, parseFloat(seconds))
}

export {
  parseHmsStrings,
  parseHmsNumbers,
  timerValue,
  timerValueFull,
  formatTimeForInput,
  splitToFloats,
}
